import { styled } from "@mui/material/styles";
import {
  CardMedia,
  Box,
  Link,
  Typography,
  Button,
  Tab,
  CardActions,
  Dialog,
  DialogContent,
  DialogTitle,
  Tabs,
} from "@mui/material";

/* Wrapper */
export const IgniteMainWrapper = styled(Box)({
  width: "100%",
});

/* Banner */
export const BannerSection = styled(Box)(({ theme }) => ({
  width: "100%",
  backgroundImage: `url(${process.env.PUBLIC_URL}/Assets/IgniteTalks/IgniteTalksBanner.jpg)`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  minHeight: "260px",
}));

/* Content inside banner */
export const BannerContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "24px",
  padding: "2% 5%",
  width: "45%",

  [theme.breakpoints.down("md")]: {
    width: "70%",
  },

  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

/* Banner title */
export const BannerTitle = styled(Typography)({
  color: "#FFFFFF",
  fontSize: "34px",
  fontWeight: 600,
  lineHeight: "normal",
});

/* Banner Button */
export const BannerButton = styled(Button)(({ theme }) => ({
  border: "3px solid #8800E8",
  backgroundColor: "#FFFFFF",
  color: "#7500C0",
  fontSize: "18px",
  fontWeight: 600,
  padding: "10px 24px",
  position: "relative",
  textTransform: "none",

  "&:hover": {
    backgroundColor: "#FFFFFF",
  },
}));

/* New badge */
export const NewBadge = styled(Typography)({
  position: "absolute",
  top: "-18px",
  right: "-18px",
  padding: "5px 10px",
  borderRadius: "10px",
  fontSize: "12px",
  color: "#FFFFFF",
  background:
    "linear-gradient(90deg, #4E0083 0%, #CB39B7 48.16%, #FD9852 64.9%)",
});

/* Button text */
export const JoinText = styled(Typography)({
  margin: "auto",
});

export const TalksWrapper = styled(Box)({
  padding: "40px 0",
  width: "90%",
  margin: "auto",
});
export const SectionHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  margin: "auto",
  gap: "16px",

  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
}));
export const SectionTitle = styled(Typography)({
  fontSize: "32px",
  fontWeight: 600,
  lineHeight: "140%",
});
/* Description text */
export const SectionDescription = styled(Typography)(({ theme }) => ({
  margin: "10px 0",
  color: "#555",
  width: "65%",

  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));
/* View recordings button-like text */
export const ViewRecordings = styled(Typography)(({ theme }) => ({
  color: "#FFFFFF",
  backgroundColor: "#7500C0",
  cursor: "pointer",
  padding: "12px",
  fontSize: "14px",
  fontWeight: 500,
  whiteSpace: "nowrap",

  "&:hover": {
    backgroundColor: "#5E00A0",
  },
}));

export const BannerMedia = styled(CardMedia)(({ theme }) => ({
  height: 320,
  backgroundRepeat: "no-repeat",
  backgroundSize: "128%",
  backgroundPosition: "0px -145px",

  [theme.breakpoints.down("md")]: {
    height: 360,
    backgroundSize: "150%",
    backgroundPosition: "0px -110px",
  },
  [theme.breakpoints.down("sm")]: {
    height: 350,
    backgroundSize: "125%",
    backgroundPosition: "0px -80px",
  },

  /* 1280px screens */
  "@media (min-width: 998px) and (max-width: 1280px)": {
    backgroundSize: "125%",
    backgroundPosition: "0px -145px",
  },
  /* 1540px screens */
  "@media (min-width: 1281px) and (max-width: 1540px)": {
    backgroundSize: "145%",
    backgroundPosition: "0px -240px",
  },

  /* 1920px screens */
  "@media (min-width: 1541px) and (max-width: 1920px)": {
    backgroundSize: "125%",
    backgroundPosition: "0px -260px",
  },
}));

export const ContentBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  padding: "3%",
  width: "55%",
});

export const CategoryChip = styled(Typography)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: "5px",
  fontWeight: 600,
  width: "fit-content",
}));

export const WatchButton = styled(Link)(({ theme }) => ({
  backgroundColor: "#F9F506",
  color: "#202020",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "8px 12px",
  fontWeight: 600,
  textDecoration: "none",
  width: "fit-content",
}));

export const StyledImg = styled("img")({
  width: "20px",
  height: "20px",
  backgroundColor: "#202020",
  borderRadius: "20px",
  marginRight: "5px",
});

export const VideoDescription = styled(Box)({
  display: "flex",
  flexDirection: "row",
  gap: "25px",
  marginTop: "10px",
});
export const VideoStyledImg = styled("img")({
  width: "15px",
  height: "15px",
  marginRight: "5px",
  // verticalAlign: "text-top",
  verticalAlign:"bottom"
});
export const IgniteWrapper = styled(Box)({
  display: "grid",
  direction: "row",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: "7px",
  width: "100%",
  padding: "10px 0px",
  height: "fit-content",
});
export const IgniteMedia = styled(CardMedia)(({ theme }) => ({
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
}));
export const IgniteDescription = styled(Box)({
  fontSize: "12px",
  color: "#606060",
  marginTop: "5px",
  height: "120px",
  overflow: "hidden",
});
export const IgniteCardIcons = styled(CardActions)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});
export const IgniteCardActions = styled(CardActions)({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  fontSize: "12px",
});
export const IgniteCardTitle = styled(Typography)({
  fontSize: "14px",
  fontWeight: 600,
  overflow: "hidden",
  minHeight: "43px",
});
export const TransparentDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    backgroundColor: "transparent",
    boxShadow: "none",
    maxWidth: "800px",
  },
  "& .MuiBackdrop-root": {
    backgroundColor: "rgba(0,0,0,0.3)",
  },
}));
export const IgniteDialogTitle = styled(DialogTitle)({
  backgroundColor: "#fff",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontWeight: 600,
  fontSize: "18px",
  color: "blueviolet",
});
export const IgniteDialogContent = styled(DialogContent)({
  backgroundColor: "#fff",
  fontSize: "14px",
});
export const DialogCloseBtn = styled(Button)({
  borderRadius: "50%",
  zIndex: "1",
  height: "30px",
  minWidth: "20px",
});
export const UpcomingSessionDetails = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "5px",
});
export const UpcomingSessionTabsWrapper = styled(Tabs)({
  "& .MuiTabs-list": {
    gap: "20px",
  },
  "& .MuiTabs-indicator": {
    display: "none",
  },
});
export const UpcomingSessionTabs = styled(Tab)({
  m: 1,
  minWidth: 190,
  backgroundColor: "#f5f3f3ff",
  color: "#555353",
  textTransform: "capitalize",
  boxShadow: "0px 2px 1px -1px rgba(0, 0, 0, 0.2)",

  "&.Mui-selected": {
    background:
      "radial-gradient(42.55% 75.65% at 56.09% 58.19%, #3E1484 30.29%, #1D0446 87.5%)",
    color: "#fff",
    fontWeight: 600,
  },
});

export const UpcomingSessionRegisterBtn = styled(Button)({
  color: "#23A6F0",
  fontWeight: 600,
  padding: "7px",
  marginTop: "10px",
  textTransform: "capitalize",
  border: "1.8px solid #23A6F0",
  textAlign: "center",
});
export const NoSearchData = styled(Typography)({
  color: "blueviolet",
  fontSize: "20px",
  marginTop: "20px",
  minHeight: "100px",
  textAlign: "center",
});

export const TitleWrapper = styled(Box)({
display: "flex",
justifyContent: "space-between",
})


////////////// Admin Section //////////

export const AddCardContentWrapper = styled(Button)({
  textTransform: "capitalize",
  "&:hover": {
    backgroundColor: "#e6e3e3",
    color: "#000",
  },
});

export const DeleteTalkBtn = styled(Button)({
  textTransform: "capitalize",
});
